export enum ChannelTypes {
  text = 'text',
  referral = 'referral',
  brandSearch = 'brand-search',
  seo = 'seo',
  direct = 'direct',
  directSeo = 'direct-seo',
}

/**
 * SEO routes
 * https://github.com/getjerry/jerry-data-pipeline/blob/main/pipeline/magic/gen_landed_v2.py#L187
 */
export const seoRoutes = [
  '/advice',
  '/car-insurance',
  '/questions',
  '/tag',
  '/insights',
  '/newsroom',
  '/car-loan',
  '/home-insurance',
  '/renters-insurance',
  '/driving',
  '/auto-news',
  '/electric-vehicles',
  '/travel',
  '/car-repair',
  '/studies',
  '/car-lease',
  '/maintenance',
  '/money',
];

/**
 * Referral and text routes
 * https://github.com/getjerry/jerry-data-pipeline/blob/main/pipeline/magic/gen_landed_v2.py#L123
 */
export const referralAndTextRoutes = ['/t/', '/invite/'];

/**
 * Search engines
 * https://github.com/getjerry/jerry-data-pipeline/blob/main/pipeline/magic/gen_landed_v2.py#L176C66-L183C34
 */
export const searchEngines = [
  'baidu',
  'googlequicksearchbox',
  'search',
  'qwant',
  'startpage',
  'google',
  'bing',
  'duckduckgo',
];
